import React from 'react'
import LazyProtectedRoute from '../LazyProtectedRoute'
import { RouteConstants } from '../../setup/routeConstants'
import Taxonomy from '../../components/Occupations/Taxonomy'
import { DomainWhitelist } from '../../components/DomainWhitelist'
import { DmdcStatsReport } from '../../components/Reports/Verification/DmdcStatsReport'
import { VaStatsReport } from '../../components/Reports/Verification/VaStatsReport'
import DocumentRuleSets from '../../components/DocumentRuleSets'
import ShopifyPayouts from '../../components/Settings/Payouts/ShopifyPayouts'
import { ACCESS_AFFILIATIONS_PAGE, ACCESS_DMDC_STATUS_PAGE, ACCESS_DOCUMENT_RULE_SETS_PAGE, ACCESS_DOMAIN_WHITELIST_PAGE, ACCESS_PAYOUTS_PAGE, ACCESS_VA_STATUS_PAGE } from '../../auth/policies'

const GlobalSettingsPage = React.lazy(() => import("../../components/GlobalSettings"))

export default {
    path: RouteConstants.settings.index.path,
    element: (
        <LazyProtectedRoute
            component={<GlobalSettingsPage />}
        />
    ),
    children: [
        {
            path: "",
            children: [
                {
                    index: true,
                    element: <LazyProtectedRoute component={<Taxonomy />} requiredPolicies={[ACCESS_AFFILIATIONS_PAGE]} />,
                },
                {
                    path: "affiliations",
                    element: <LazyProtectedRoute component={<Taxonomy />} requiredPolicies={[ACCESS_AFFILIATIONS_PAGE]} />,
                },
                {
                    path: "domain-whitelist",
                    element: <LazyProtectedRoute component={<DomainWhitelist />} requiredPolicies={[ACCESS_DOMAIN_WHITELIST_PAGE]} />,
                },
                {
                    path: "dmdc-status",
                    element: <LazyProtectedRoute component={<DmdcStatsReport />} requiredPolicies={[ACCESS_DMDC_STATUS_PAGE]} />,
                },
                {
                    path: "va-status",
                    element: <LazyProtectedRoute component={<VaStatsReport />} requiredPolicies={[ACCESS_VA_STATUS_PAGE]} />,
                },
                {
                    path: "document-rule-sets",
                    element: <LazyProtectedRoute component={<DocumentRuleSets />} requiredPolicies={[ACCESS_DOCUMENT_RULE_SETS_PAGE]} />,
                },
                {
                    path: "shopify-payouts",
                    element: <LazyProtectedRoute component={<ShopifyPayouts />} requiredPolicies={[ACCESS_PAYOUTS_PAGE]} />,
                }

            ]
        },

    ]
}
